import api from './api';

export const fetchCompliances = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] = queryKey;
  let url = `/compliance?page=${page}&limit=${limit}`;
  
  if (search) {
    // url += `&search=${search}`;

    let searchValue = search;

    // Add + prefix for phone numbers when exact match is enabled
    if (searchBy?.includes('phoneNumber') && searchByExactMatch) {
      // Remove any existing + and non-digit characters
      const digitsOnly = search.replace(/\D/g, '');

      // Add + prefix if it's a Nigerian number (starts with 234)
      if (digitsOnly.startsWith('234') && digitsOnly.length > 3) {
        searchValue = `+${digitsOnly}`;
      }
    }

    // Encode the search value to handle special characters like +
    url += `&search=${encodeURIComponent(searchValue)}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${encodeURIComponent(field)}`).join('&');
    // const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
};

export const fetchCompliance = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/compliance/single/${id}`);
  return response.data;
};

export const fetchComplianceVerification = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/compliance/${id}/verifications`);
  return response.data;
};

export const approveOrRejectCompliance = async (id, data) => {
  const response = await api.post(`/compliance/${id}/approve-or-reject`, data);
  return response.data;
};
export const approveSelfieCompliance = async (id, data) => {
  const response = await api.patch(`/compliance/${id}/approve/selfie`, data);
  return response.data;
};

export const exportCompliance = async (data) => {
  const response = await api.post(`/export/compliance`, data);
  return response.data;
}

export const fetchComplianceMetrics = async ({ queryKey }) => {
  const [, { fetch, startDate, endDate }] = queryKey;

  // Build the query parameters
  let query = '';

  // Only add fetch if startDate and endDate are not provided
  if (!startDate && !endDate) {
    query += `fetch=${fetch}`;
  }

  // Add startDate and endDate to the query if provided
  if (startDate) {
    query += (query ? '&' : '') + `startDate=${startDate}`;
  }
  if (endDate) {
    query += (query ? '&' : '') + `endDate=${endDate}`;
  }

  const response = await api.get(`/compliance/metrics?${query}`);
  return response.data;
};